import { useTranslation } from 'react-i18next'
import React from 'react'

import { TabsContext } from '../../../components/tabs/TabsContext'
import ControlledModal from '../../../components/modals/ControlledModal'
import Details from './Details'
import Line from '../../../packages/kiti/components/helpers/Line'
import ModalHeader from './ModalHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import TriggerCallLoader from './_load/TriggerCallLoader'

export const useTabsOptions = () => {
  const { t } = useTranslation('triggerCalls')
  return [
    { name: t('tabs.result'), value: 'result' },
    { name: t('tabs.payload'), value: 'payload' },
    { name: t('tabs.entity'), value: 'record' },
    { name: t('tabs.trigger'), value: 'trigger' },
    { name: t('tabs.rest'), value: 'rest' }
  ]
}

const ShowTriggerCallModal = props => {
  const tabsOptions = useTabsOptions()
  return (
    <ControlledModal width="76rem" {...props}>
      <TabsContext options={tabsOptions}>
        <TriggerCallLoader>
          <ModalHeader />

          <Line color="light2" />

          <Separator weight={6} />
          <Details />
        </TriggerCallLoader>
      </TabsContext>
    </ControlledModal>
  )
}

export default ShowTriggerCallModal
